// extracted by mini-css-extract-plugin
export var divider = "_pu-0";
export var systemMessage = "_pu-1";
export var systemMessageWrapper = "_pu-2";